export default __webpack_public_path__ + "static/media/reviews.ff5f0592.png";